import Header from 'modules/header/components/header'
import styled, { css } from 'styled-components'
import Footer from '../shared/components/footer'
import SupportCTA from '../shared/components/support-cta'
import { ContainerBlock, WrapperBlock } from '../../blocks'
import Gradient from '../../welcome/copy/gradient'
import { giphyBlue } from '@giphy/js-brand'

const Container = styled(ContainerBlock as any)`
    background: none;
    padding: 80px 80px 40px;
`

const baseStyles = css`
    display: block;
    height: 100%;
    left: 0;
    opacity: 0.3;
    pointer-events: none;
    position: fixed;
    top: 0;
    width: 100%;
    z-index: -1;
`

const Video = styled.video`
    ${baseStyles}
    object-fit: cover;
`

const Content = styled.div`
    position: relative;
    width: 100%;
`

const Peeker = styled.img`
    left: 50%;
    margin-left: -90px;
    pointer-events: none;
    position: absolute;
    top: 0;
    transform: translateY(-50%) scaleX(-1);
    width: 180px;
`

const MessageContainer = styled.div`
    text-align: center;
    padding: 60px 0;
`

const Title = styled.div`
    font-family: NexaBlack;
    font-size: 26px;
    height: 32px;
    letter-spacing: 0px;
    width: 350px;
    margin: 0 auto;
`

const Message = styled.div`
    font-size: 17px;
    font-weight: normal;
    height: 60px;
    text-align: center;
    width: 500px;
    margin: 25px auto 0 auto;

    p {
        text-align: center;
    }

    a {
        color: ${giphyBlue};
    }
`

const NoMatch = () => {
    return (
        <>
            <Video src={'/static/img/videos/gachapon.mp4'} muted playsInline autoPlay loop />
            <Header />
            <WrapperBlock>
                <Container>
                    <Gradient />
                    <Content>
                        <MessageContainer>
                            <Title>Error 404</Title>
                            <Message>
                                <p>
                                    Oops, this page can’t be found! This can happen when a capture has been deleted, or
                                    maybe our server got tired &amp; fell asleep.
                                </p>
                                <a href="/supercut">Return to Capture Library</a>
                            </Message>
                        </MessageContainer>
                        <SupportCTA />
                        <Footer />
                    </Content>
                    <Peeker src={'/static/img/error_pages/crying-cowbow-emoji.gif'} alt="" />
                </Container>
            </WrapperBlock>
        </>
    )
}

export default NoMatch
